<template>
    <div class="recommend-layer">
        <div class="content-wrap">
            <div class="go-mobile">
                <img :src="wechat" alt="wechat">
                <p>手机扫码邀请好友</p>
            </div>
            <a class="btn-item btn-close" href="javascript: void(0)" @click="closeRecommend"></a>
        </div>
    </div>
</template>

<script>
import wechat from '@/assets/images/wechat.png'
export default {
    name: "RecommendLayer",
    data () {
        return {
            wechat
        }
    },
    methods: {
        closeRecommend () {
            this.$store.commit('showRecommendLayer', false)
        }
    },
    computed: {
        isShowRecommendLayer () {
            return this.$store.state.app.isShowRecommendLayer
        }
    }
}
</script>

<style lang="less" scoped>
 .recommend-layer{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.85);
    .content-wrap{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 723px;
        height: 483px;
        background: url("../../assets/images/recommend.png") no-repeat;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        .go-mobile{
            position: absolute;
            left: 428px;
            top: 254px;
            width: 167px;
            text-align: center;
            p{
                margin-top: 6px;
                color: #25388a;
                line-height: 22px;
                font-size: 16px;
                letter-spacing: 2px;
            }
        }
        .btn-close{
            position: absolute;
            right: 0;
            top: -40px;
            width: 40px;
            height: 40px;
            background: url("../../assets/images/close.png") no-repeat center center;
            background-size: 26px 26px;
        }
    }
}
</style>